{
  "account.breadcrumb": {
    "translation": "My account"
  },
  "account.hub.documentTitle": {
    "translation": "My account"
  },
  "account.hub.security": {
    "translation": "Security"
  },
  "account.passkeys.breadcrumb": {
    "translation": "Passkeys and security"
  },
  "account.passkeys.documentTitle": {
    "translation": "Passkeys and security"
  },
  "auth-action.enter-code": {
    "translation": "Enhanced Security Code"
  },
  "auth-action.forgot-password": {
    "translation": "Forgot password"
  },
  "auth-action.loading": {
    "translation": "Loading..."
  },
  "auth-action.reset-password": {
    "translation": "Password reset"
  },
  "auth-action.sign-in": {
    "translation": "Sign in"
  },
  "auth-action.sign-out": {
    "translation": "Sign out"
  },
  "auth-provider.authentication-failed": {
    "translation": "Authentication failed"
  },
  "auth-provider.google-authentication-failed": {
    "translation": "Google authentication failed"
  },
  "auth-provider.passkey-authentication-failed": {
    "translation": "Passkey login failed. Verify that a passkey is registered for this account."
  },
  "auth-provider.password-authentication-failed": {
    "translation": "Incorrect email or password"
  },
  "auth.brand-panel.body": {
    "translation": "Giving every business the means for effective, distinctive digital communication."
  },
  "auth.brand-panel.headline": {
    "translation": "Amplify what's next"
  },
  "auth.email-sent.back": {
    "translation": "Back to login page"
  },
  "auth.email-sent.email-sent": {
    "translation": "An email has been sent to <email></email> with instructions to reset your password 🚀"
  },
  "auth.email-sent.resend": {
    "translation": "I didn't receive an email"
  },
  "auth.email-sent.wrong-email": {
    "translation": "I entered the wrong email address"
  },
  "auth.enter-code-form.invalid-code": {
    "translation": "Please enter a valid code"
  },
  "auth.enter-code-form.label": {
    "translation": "Enter code"
  },
  "auth.enter-code-form.submit": {
    "translation": "Sign in"
  },
  "auth.enter-code-form.trust-device": {
    "translation": "Trust this browser"
  },
  "auth.enter-code-form.trust-device-tooltip": {
    "translation": "Check this box if you are the only user of this browser and it is your computer. We will remember this information, and you won't need to enter a code for 30 days."
  },
  "auth.enter-code.forgot-password": {
    "translation": "Forgot password / First login"
  },
  "auth.enter-code.no-account": {
    "translation": "No account yet with this address? Go to the link below:"
  },
  "auth.enter-code.not-received": {
    "translation": "Didn't receive anything? Our validation emails sometimes end up in spam."
  },
  "auth.enter-code.title": {
    "translation": "To secure your access, please enter the code that has just been sent to your email address:"
  },
  "auth.forgot-password-form.email": {
    "translation": "Email"
  },
  "auth.forgot-password-form.email-invalid": {
    "translation": "The email is invalid"
  },
  "auth.forgot-password-form.email-placeholder": {
    "translation": "Enter your email"
  },
  "auth.forgot-password-form.submit": {
    "translation": "Send"
  },
  "auth.forgot-password.back": {
    "translation": "Back to login page"
  },
  "auth.forgot-password.forgot-password-message": {
    "translation": "Please enter your email to receive the password reset link"
  },
  "auth.layout.header-wrapper.advertising-manager": {
    "translation": "Dashboard"
  },
  "auth.login-form.change-email": {
    "translation": "Change"
  },
  "auth.login-form.continue": {
    "translation": "Continue"
  },
  "auth.login-form.credentials-invalid": {
    "translation": "Incorrect email or password"
  },
  "auth.login-form.email": {
    "translation": "Email"
  },
  "auth.login-form.email-invalid": {
    "translation": "Please enter a valid email address"
  },
  "auth.login-form.email-placeholder": {
    "translation": "Enter your email"
  },
  "auth.login-form.password": {
    "translation": "Password"
  },
  "auth.login-form.password-invalid": {
    "translation": "Please enter your password"
  },
  "auth.login-form.password-placeholder": {
    "translation": "Enter your password"
  },
  "auth.login-form.submit": {
    "translation": "Log in"
  },
  "auth.login-form.too-many-attempts": {
    "placeholders": {
      "minutes": ["Math.max(1, Math.ceil(outcome.retryAfterSeconds / 60))"]
    },
    "translation": "Too many attempts. Try again in {minutes} minutes."
  },
  "auth.login-form.too-many-attempts-soon": {
    "translation": "Too many attempts. Try again in a moment."
  },
  "auth.login.forgotton-password": {
    "translation": "Forgot password / First login?"
  },
  "auth.login.or": {
    "translation": "or"
  },
  "auth.passkey-enrollment.activate": {
    "translation": "Activate"
  },
  "auth.passkey-enrollment.cancel": {
    "translation": "Cancel"
  },
  "auth.passkey-enrollment.description": {
    "translation": "Use fingerprint or face recognition for your next logins by activating it."
  },
  "auth.passkey-enrollment.error-challenge": {
    "translation": "Invalid server response for passkey registration."
  },
  "auth.passkey-enrollment.error-generic": {
    "translation": "Passkey registration failed."
  },
  "auth.passkey-enrollment.error-no-webauthn": {
    "translation": "Your browser does not support passkeys."
  },
  "auth.passkey-enrollment.error-register": {
    "translation": "Unable to register passkey."
  },
  "auth.passkey-enrollment.error-title": {
    "translation": "Cannot set up passkey"
  },
  "auth.passkey-enrollment.later": {
    "translation": "Later"
  },
  "auth.passkey-enrollment.title": {
    "translation": "Sign in without a password"
  },
  "auth.passkey-enrollment.verifying-hint": {
    "translation": "Tap Touch ID or look at Face ID to confirm."
  },
  "auth.passkey-enrollment.verifying-title": {
    "translation": "Activating your passkey…"
  },
  "auth.password-tooltip.mandatory-rules": {
    "translation": "Your password must have:"
  },
  "auth.password-tooltip.mandatory-rules.length": {
    "translation": "at least 8 characters"
  },
  "auth.password-tooltip.mandatory-rules.lowercase": {
    "translation": "at least 1 lowercase letter"
  },
  "auth.password-tooltip.mandatory-rules.number": {
    "translation": "at least 1 number"
  },
  "auth.password-tooltip.mandatory-rules.special-character": {
    "translation": "at least 1 special character"
  },
  "auth.password-tooltip.mandatory-rules.uppercase": {
    "translation": "at least 1 uppercase letter"
  },
  "auth.password-tooltip.recommended-rules": {
    "translation": "Avoid passwords you use on other sites or that someone else could easily guess."
  },
  "auth.password-tooltip.security": {
    "translation": "Password security:"
  },
  "auth.password-tooltip.security.medium": {
    "translation": "medium"
  },
  "auth.password-tooltip.security.strong": {
    "translation": "strong"
  },
  "auth.password-tooltip.security.weak": {
    "translation": "weak"
  },
  "auth.pat-sign-in.manual-placeholder": {
    "translation": "Paste a personal access token"
  },
  "auth.pat-sign-in.manual-submit": {
    "translation": "Sign in"
  },
  "auth.pat-sign-in.no-profiles": {
    "translation": "No token found in ~/.mobsuccess.yml"
  },
  "auth.pat-sign-in.separator": {
    "translation": "or sign in with a token"
  },
  "auth.query-error-notifier.description": {
    "translation": "Our team is already on it. Reload the page to pick up where you left off."
  },
  "auth.query-error-notifier.reload": {
    "translation": "Reload"
  },
  "auth.query-error-notifier.title": {
    "translation": "Oops, something didn’t work"
  },
  "auth.reset-password.back": {
    "translation": "Back to login page"
  },
  "auth.reset-password.confirm-password.label": {
    "translation": "Confirm password"
  },
  "auth.reset-password.confirm-password.placeholder": {
    "translation": "Password"
  },
  "auth.reset-password.password-validation-error.miss-match": {
    "translation": "Passwords do not match"
  },
  "auth.reset-password.password-validation-error.weak": {
    "translation": "The password is too weak, please choose a stronger one"
  },
  "auth.reset-password.password.label": {
    "translation": "Password"
  },
  "auth.reset-password.password.placeholder": {
    "translation": "Password"
  },
  "auth.reset-password.submit": {
    "translation": "Validate"
  },
  "index.redirecting-loader": {
    "translation": "Redirecting…"
  },
  "language-select.error-description": {
    "translation": "This language is not supported"
  },
  "language-select.error-title": {
    "translation": "Error changing language"
  },
  "passkeys-account.add-connection": {
    "translation": "Add connection"
  },
  "passkeys-account.add-connection-busy": {
    "translation": "Registering…"
  },
  "passkeys-account.add-connection-busy-hint": {
    "translation": "Respond to the prompt in your browser or on your device (fingerprint, face, or security key)."
  },
  "passkeys-account.created": {
    "translation": "Created:"
  },
  "passkeys-account.default-name": {
    "translation": "Passkey"
  },
  "passkeys-account.delete": {
    "translation": "Delete"
  },
  "passkeys-account.delete-cancel": {
    "translation": "Cancel"
  },
  "passkeys-account.delete-confirm": {
    "translation": "Delete this passkey?"
  },
  "passkeys-account.delete-passkey": {
    "translation": "Delete"
  },
  "passkeys-account.empty": {
    "translation": "No passkeys registered."
  },
  "passkeys-account.error.generic": {
    "translation": "An error occurred."
  },
  "passkeys-account.error.invalid-challenge": {
    "translation": "Invalid server response (missing challenge)."
  },
  "passkeys-account.error.no-webauthn": {
    "translation": "Your browser does not support passkeys."
  },
  "passkeys-account.error.register-failed": {
    "translation": "Passkey registration failed."
  },
  "passkeys-account.hub.title": {
    "translation": "My Account"
  },
  "passkeys-account.last-used-label": {
    "translation": "Last used:"
  },
  "passkeys-account.last-used.just-now": {
    "translation": "Just now"
  },
  "passkeys-account.last-used.minutes-ago": {
    "placeholders": {
      "minutes": ["diffMin"]
    },
    "translation": "{minutes} min ago"
  },
  "passkeys-account.loading": {
    "translation": "Loading…"
  },
  "passkeys-account.page.title": {
    "translation": "Passkeys and Security Keys"
  },
  "passkeys-account.quick-login.intro": {
    "translation": "Manage your passkey keychain to sign in without a password."
  },
  "passkeys-account.quick-login.subtitle": {
    "translation": "Manage your passwordless connections"
  },
  "passkeys-account.quick-login.title": {
    "translation": "Passkeys and security keys"
  },
  "passkeys-account.registered-connections": {
    "translation": "Registered connections"
  },
  "root.pending-loader": {
    "translation": "Loading…"
  },
  "src.public.auth.forgot-password-error.button-text": {
    "translation": "Contact us"
  },
  "src.public.auth.forgot-password-error.description": {
    "translation": "We could not send you the password reset link. Please try again later."
  },
  "src.public.auth.forgot-password-error.description-npai": {
    "translation": "An error concerning your account could not be resolved. Please contact support providing a different email address."
  },
  "src.public.auth.forgot-password-error.title": {
    "translation": "Something went wrong"
  },
  "src.public.auth.reset-password-error.description": {
    "translation": "We could not reset your password. Please request a new password reset link."
  },
  "src.public.auth.reset-password-error.title": {
    "translation": "An error occurred"
  },
  "src.public.auth.reset-password-success.description": {
    "translation": "You can now log in with your new password!"
  },
  "src.public.auth.reset-password-success.title": {
    "translation": "Your password has been successfully reset 🚀"
  },
  "src.public.use-send-2fa-auth.error.title": {
    "translation": "An error occurred"
  },
  "theme-switch.to-dark": {
    "translation": "Switch to the dark theme"
  },
  "theme-switch.to-light": {
    "translation": "Switch to the light theme"
  }
}
